
import { FormPage } from '@/mixins'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Services } from 'tradingmate-modules/src/services'
import { BusinessBranchModel } from 'tradingmate-modules/src/models/api/businesses'
import PackageCheckout from '@/components/collections/account/PackageCheckout.vue'
import { UserModel } from 'tradingmate-modules/src/models/api/users'

@Component({
  components: {
    PackageCheckout
  }
})
export default class Membership extends Mixins(FormPage) {
  private branch: BusinessBranchModel | null = null
  private user: UserModel | null = null

  @Prop({ default: null })
  private propBranch!: BusinessBranchModel | null

  mounted (): void {
    if (this.propBranch)
    {
      this.branch = this.propBranch
    }
    else {
      const id = this.$route.params.id
      if (!id) return

      this.loading = true
      Services.API.Businesses.GetBranch(id)
        .then((result) => {
          this.branch = result
        })
        .catch((errors) => {
          console.log(errors)
        })

      Services.API.Businesses.GetUserForBusinessBranch(id)
        .then((result) => {
          this.user = result
        })
        .catch((errors) => {
          console.log(errors)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
